<template>
  <div
    class="slider"
    @mouseenter="mouseEnter()"
    @mouseleave="mouseLeave()"
  >
    <SliderControllers @showPrev="showPrev" @showNext="showNext" :displayPrev="true" :displayNext="true" :hideMobile="false" :small="true"/>
    <div class="slide-wrapper">
      <div
        class="slide"
        v-for="(item, index) in items"
        :key="'item' + index"
        :class="{
          prev: index == (activeItem - 1 + items.length) % items.length,
          active: index == activeItem,
          next: index == (activeItem + 1) % items.length
        }"
      >
        <p v-accent="item"></p>
      </div>
    </div>
  </div>
</template>

<script>
import SliderControllers from '@/components/SliderControllers.vue'

export default {
  name: 'textSlider',
  props: ['items'],
  components: {
    SliderControllers
  },
  data: function () {
    return {
      activeItem: 0,
      loop: true,
      loopTimeout: null
    }
  },
  methods: {
    showNext () {
      this.activeItem = this.activeItem + 1 < this.items.length
        ? Math.min(this.activeItem + 1, this.items.length - 1)
        : 0
      this.loop = false
      window.clearTimeout(this.loopTimeout)
    },
    loopNext () {
      if (this.loop) {
        this.activeItem = this.activeItem + 1 < this.items.length
          ? Math.min(this.activeItem + 1, this.items.length - 1)
          : 0
        this.loopTimeout = window.setTimeout(() => {
          this.loopNext()
        }, 4000)
      }
    },
    showPrev () {
      this.activeItem = this.activeItem - 1 >= 0
        ? Math.max(this.activeItem - 1, 0)
        : this.items.length - 1
      this.loop = false
      window.clearTimeout(this.loopTimeout)
    },
    mouseEnter () {
      window.clearTimeout(this.loopTimeout)
      this.loop = false
    },
    mouseLeave () {
      this.loop = true
      setTimeout(() => {
        this.loopNext()
      }, 1000)
    }
  },
  mounted () {
    setTimeout(this.loopNext, 5000)
  }
}
</script>

<style scoped lang="scss">
  .slide {
    align-items: center;
    display: none;
    font-weight: 500;
    overflow: hidden;
    opacity: 0;
    padding: 0;
    position: relative;
    text-align: left;
    transition: $transitionSlider;
    width: 0;
    z-index: 1;
    &.prev,
    &.next,
    &.active {
      align-content: center;
      display: flex;
      height: 100%;
      width: 100%;
    }
    &.prev,
    &.next {
      position: absolute;
      top: 0;
    }
    &.prev {
      left: 0;
      transform: translateX(-100vw);
    }
    &.next {
      left: auto;
      right: 0;
      transform: translateX(100vw);
      transition: $transitionTextSlider;
    }
    &.active {
      transform: translateX(0);
      opacity: 1;
    }
    @include mobile {
      .font-size-l & {
        p {
          margin: 0;
        }
      }
    }
  }
  .controllers {
    position: absolute;
    z-index: 3;
    top: 50%;
    transform: translateY(-50%);
    left: 0;
    width: 90px;
    height: 100%;
    @include mobile {
      height: 40px;
      top: -32px;
      width: 70px;
      transform: translateY(0);
    }
  }
  .slide-wrapper {
    align-items: center;
    display: flex;
    position: relative;
    width: 350px;
    max-width: 90%;
    overflow: hidden;
    min-height: 120px;
    text-align: left;
    margin-left: 110px;
    @include mobile {
      margin: 0;
      width: 100%;
      max-width: 100%;
      min-height: 120px;
      top: 0;
      .font-size-l & {
        min-height: 140px;
        margin: 20px 0;
      }
    }
    @include mobile-small {
      margin-left: 0;
      min-height: 120px;
      width: 100%;
      .font-size-l & {
        min-height: 140px;
      }
    }
  }
  .slider {
    position: absolute;
    z-index: 99999;
    left: -18px;
    animation-name: slideranimation;
    animation-timing-function: ease-in-out;
    animation-iteration-count: 1;
    animation-duration: 6s;

    bottom: 10px;
    left: 0;
    width: 100%;

    @include screen ('sm') {
      bottom: 15vh;
    }

    @include screen ('md') {
      bottom: 10vh;
      width: auto;
    }
    @include screen ('770px', true) {
      bottom: 20vh;
    }
  }
</style>
